import { WorkOrderHistoryComponent } from './work-order-history.component';
import { CoreModule } from './../../core/core.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

@NgModule({
  imports: [
    CommonModule,
    CoreModule,
  ],
  declarations: [
    WorkOrderHistoryComponent
  ],
  entryComponents: [
    WorkOrderHistoryComponent
  ],
  exports: [
    WorkOrderHistoryComponent
  ],
  providers: []
})
export class WorkOrderHistoryModule { }
